import { useCallback } from "react";

import type { OptionPmsColorItemInput } from "@/lib/gql/__generated__/graphql";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import * as Repository from "../../../_repository";

type Props = {
	hotelID: string;
};

export const useUpdateOptionPmsColorItem = ({ hotelID }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	/**
	 * カラーの更新
	 */
	const { onUpdateOptionPmsColorItemUpdate } = Repository.Mutation.UseCase.useOptionPmsColorItemUpdateMutation();
	const onUpdateOptionPmsColorItem = useCallback(
		async ({
			optionID,
			color,
			successCallback,
		}: {
			optionID: string;
			color: string;
			successCallback: () => void;
		}) => {
			showLoadingScreenCallback();

			const input: OptionPmsColorItemInput = {
				hotelID,
				optionID,
				color,
			} satisfies OptionPmsColorItemInput;

			await onUpdateOptionPmsColorItemUpdate(input)
				.then(({ errors }) => {
					if (!errors) {
						notifyUserEventInfo({ variant: "default", title: "色を更新しました" });
						successCallback();
					}
				})
				.finally(() => hideLoadingScreenCallback());
		},
		[hideLoadingScreenCallback, hotelID, onUpdateOptionPmsColorItemUpdate, showLoadingScreenCallback],
	);

	return {
		// 色の更新
		onUpdateOptionPmsColorItem,
	};
};
